import React from 'react';

const CennikImportModal = ({
  cennikPreview, cennikOptions, setCennikOptions,
  cennikFilter, setCennikFilter, cennikSearch, setCennikSearch,
  isSavingCennik, getFilteredCennikProducts, onSave, onClose
}) => {
  if (!cennikPreview) return null;

  const produkty = cennikPreview.products || [];
  const stats = cennikPreview.stats || {};

  // Filtr 'wymaga_uzupelnienia' jest nowy - jesli przekazana funkcja go nie zna,
  // dofiltrowujemy lokalnie (getFilteredCennikProducts zwraca wtedy caly zbior).
  let filtered = getFilteredCennikProducts();
  if (cennikFilter === 'wymaga_uzupelnienia') {
    filtered = filtered.filter(p => p.wymaga_uzupelnienia);
  }

  // Liczniki liczone z pozycji, gdy backend ich nie poda w stats
  const wymagaUzupelnienia = stats.wymaga_uzupelnienia != null
    ? stats.wymaga_uzupelnienia
    : produkty.filter(p => p.wymaga_uzupelnienia).length;
  const zeroweCeny = stats.zerowe_ceny != null
    ? stats.zerowe_ceny
    : produkty.filter(p => !(parseFloat(p.cena_brutto) > 0)).length;
  const zmianyCen = produkty.filter(p => p.price_differs && parseFloat(p.cena_brutto) > 0).length;

  const opisFiltru = {
    mapped: 'zmapowane',
    new: 'nowe',
    name_changes: 'zmiany nazw',
    wymaga_uzupelnienia: 'wymaga uzupełnienia'
  };

  // Przycisk filtru wg kanonicznego wzorca projektu (TodayReceiptsModal):
  // AKTYWNY = pelne tlo w kolorze semantycznym + #fff,
  // NIEAKTYWNY = var(--text-secondary) na var(--card-bg) z kolorowa RAMKA.
  // Kolorowy tekst 11px na bialym tle dawal 2.15-3.76:1 (ponizej WCAG AA 4.5:1),
  // a inline tlo blokowalo korekte z motywu.
  const filterBtnStyle = (klucz, kolor) => ({
    padding: '4px 10px', fontSize: '11px', borderRadius: '4px', cursor: 'pointer',
    border: `1px solid ${kolor}`,
    backgroundColor: cennikFilter === klucz ? kolor : 'var(--card-bg)',
    color: cennikFilter === klucz ? '#fff' : 'var(--text-secondary)',
    fontWeight: cennikFilter === klucz ? '600' : '500'
  });

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px', width: '95%', maxWidth: '1400px',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          padding: '1rem', borderBottom: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: 'linear-gradient(135deg, var(--info), var(--info))'
        }}>
          <div style={{ color: '#fff' }}>
            <h5 style={{ margin: 0, fontSize: '16px' }}>{'💰'} Import cennika XML</h5>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>
              Plik: {cennikPreview.filename} | {cennikPreview.stats?.total || 0} produkt{'ó'}w
            </div>
          </div>
          <button onClick={onClose}
            style={{ background: 'var(--bg-secondary)',  color: 'var(--text)' ,
              fontSize: '20px', cursor: 'pointer', padding: '4px 10px' }}>{'×'}</button>
        </div>

        {/* Stats & Options */}
        <div style={{ padding: '1rem', borderBottom: '1px solid var(--border)', backgroundColor: 'var(--bg)' }}>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', alignItems: 'center', marginBottom: '1rem' }}>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--success-light)', borderRadius: '4px', cursor: 'pointer', border: cennikFilter === 'mapped' ? '2px solid var(--success)' : 'none' }}
                onClick={() => setCennikFilter(cennikFilter === 'mapped' ? 'all' : 'mapped')}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--success)' }}>{cennikPreview.stats?.mapped || 0}</div>
                <div style={{ fontSize: '10px', color: 'var(--success)' }}>{'✅'} Zmapowane</div>
              </div>
              <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--warning-light)', borderRadius: '4px', cursor: 'pointer', border: cennikFilter === 'new' ? '2px solid var(--warning)' : 'none' }}
                onClick={() => setCennikFilter(cennikFilter === 'new' ? 'all' : 'new')}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--warning)' }}>{cennikPreview.stats?.new || 0}</div>
                <div style={{ fontSize: '10px', color: 'var(--warning)' }}>{'➕'} Nowe</div>
              </div>
              <div style={{ textAlign: 'center', padding: '0.5rem 1rem', backgroundColor: 'var(--info-light)', borderRadius: '4px', cursor: 'pointer', border: cennikFilter === 'name_changes' ? '2px solid var(--info)' : 'none' }}
                onClick={() => setCennikFilter(cennikFilter === 'name_changes' ? 'all' : 'name_changes')}>
                <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--info)' }}>{cennikPreview.stats?.name_changes || 0}</div>
                <div style={{ fontSize: '10px', color: 'var(--info)' }}>{'📝'} Zmiana nazwy</div>
              </div>
            </div>

            <input
              type="text"
              placeholder={'🔍 Szukaj produktu...'}
              value={cennikSearch}
              onChange={e => setCennikSearch(e.target.value)}
              style={{
                padding: '6px 10px', fontSize: '12px', borderRadius: '6px',
                border: '1px solid var(--border)', minWidth: '250px',
                backgroundColor: 'var(--card-bg)', color: 'var(--text)'
              }}
            />
          </div>

          <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer', padding: '0.5rem', backgroundColor: cennikOptions.update_prices ? 'var(--success-light)' : 'var(--bg)', borderRadius: '4px', border: '1px solid var(--border)' }}>
              <input type="checkbox" checked={cennikOptions.update_prices}
                onChange={e => setCennikOptions(prev => ({ ...prev, update_prices: e.target.checked }))} />
              {'💰'} Aktualizuj ceny sprzeda{'ż'}y
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer', padding: '0.5rem', backgroundColor: cennikOptions.update_names ? 'var(--success-light)' : 'var(--bg)', borderRadius: '4px', border: '1px solid var(--border)' }}>
              <input type="checkbox" checked={cennikOptions.update_names}
                onChange={e => setCennikOptions(prev => ({ ...prev, update_names: e.target.checked }))} />
              {'📝'} Aktualizuj nazwy produkt{'ó'}w
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '12px', cursor: 'pointer', padding: '0.5rem', backgroundColor: cennikOptions.create_new ? 'var(--success-light)' : 'var(--bg)', borderRadius: '4px', border: '1px solid var(--border)' }}>
              <input type="checkbox" checked={cennikOptions.create_new}
                onChange={e => setCennikOptions(prev => ({ ...prev, create_new: e.target.checked }))} />
              {'➕'} Tw{'ó'}rz nowe produkty
            </label>
          </div>

          {/* Filtry pozycji. Zmapowane / Nowe / Zmiana nazwy sa juz klikalne
              na kafelkach statystyk powyzej - NIE dublujemy ich tutaj. */}
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '0.75rem' }}>
            <button onClick={() => setCennikFilter('all')} style={filterBtnStyle('all', 'var(--primary)')}>
              Wszystkie ({stats.total || produkty.length})
            </button>
            <button onClick={() => setCennikFilter('wymaga_uzupelnienia')} style={filterBtnStyle('wymaga_uzupelnienia', 'var(--danger)')}>
              Wymaga uzupe{'ł'}nienia ({wymagaUzupelnienia})
            </button>
          </div>
        </div>

        {/* Paski ostrzegawcze */}
        {(wymagaUzupelnienia > 0 || zeroweCeny > 0 || zmianyCen > 0) && (
          <div style={{ padding: '0.5rem 1rem 0', display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
            {wymagaUzupelnienia > 0 && (
              <div style={{
                fontSize: '12px', padding: '0.4rem 0.6rem', borderRadius: '4px',
                backgroundColor: 'var(--danger-light)', border: '1px solid var(--danger)', color: 'var(--danger)', fontWeight: '600'
              }}>
                {'⛔'} {wymagaUzupelnienia} pozycji bez nazwy lub bez stawki VAT {'—'} nie zostan{'ą'} utworzone.
              </div>
            )}
            {zeroweCeny > 0 && (
              <div style={{
                fontSize: '12px', padding: '0.4rem 0.6rem', borderRadius: '4px',
                backgroundColor: 'var(--warning-light)', border: '1px solid var(--warning)', color: 'var(--warning)'
              }}>
                {'⚠️'} {zeroweCeny} pozycji ma cen{'ę'} 0 {'—'} cena sprzeda{'ż'}y tych produkt{'ó'}w nie zostanie zmieniona.
              </div>
            )}
            {zmianyCen > 0 && (
              <div style={{
                fontSize: '12px', padding: '0.4rem 0.6rem', borderRadius: '4px',
                backgroundColor: 'var(--info-light)', border: '1px solid var(--info)', color: 'var(--info)'
              }}>
                {'ℹ️'} Zmieni cen{'ę'} sprzeda{'ż'}y {zmianyCen} produktom.
              </div>
            )}
          </div>
        )}

        {/* Product list */}
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto', padding: '0.5rem' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px' }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: 'var(--bg)', zIndex: 10 }}>
              <tr>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)', width: '60px' }}>Status</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)', width: '120px' }}>Kod</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)', width: '140px' }}>EAN</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Nazwa z cennika</th>
                <th style={{ padding: '0.5rem', textAlign: 'left', borderBottom: '2px solid var(--border)' }}>Nazwa w systemie</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)', width: '100px' }}>Cena cennika</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)', width: '100px' }}>Obecna cena</th>
                <th style={{ padding: '0.5rem', textAlign: 'right', borderBottom: '2px solid var(--border)', width: '60px' }}>VAT</th>
              </tr>
            </thead>
            <tbody>
              {filtered.slice(0, 200).map((p, idx) => {
                const priceDiff = p.is_mapped && p.existing_price !== p.cena_brutto;
                const nameDiff = p.is_mapped && p.name_differs;
                // Brak jawnej stawki w pliku - NIE pokazujemy falszywego 23%
                const brakVat = p.stawka_vat === null || p.stawka_vat === undefined
                  || p.stawka_vat_z_dokumentu === false;

                return (
                  <tr key={idx} style={{
                    backgroundColor: p.is_mapped
                      ? (nameDiff ? 'var(--info-light)' : (idx % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)'))
                      : 'var(--warning-light)'
                  }}>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)' }}>
                      {p.is_mapped ? (nameDiff ? '📝' : '✅') : '➕'}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', fontFamily: 'monospace', fontSize: '10px' }}>
                      {p.kod || '-'}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', fontFamily: 'monospace', fontSize: '10px' }}>
                      {p.ean || '-'}
                    </td>
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)',
                      maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                      fontWeight: nameDiff ? '600' : 'normal'
                    }}>
                      {p.nazwa}
                    </td>
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)',
                      maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                      color: p.is_mapped ? (nameDiff ? 'var(--danger)' : 'var(--success)') : 'var(--text-muted)',
                      fontStyle: nameDiff ? 'italic' : 'normal'
                    }}>
                      {p.existing_name || (p.is_mapped ? '-' : '(nowy produkt)')}
                    </td>
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right',
                      fontWeight: '600', color: priceDiff ? 'var(--info)' : 'var(--text)'
                    }}>
                      {(p.cena_brutto || 0).toFixed(2)} z{'ł'}
                    </td>
                    <td style={{
                      padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right',
                      color: priceDiff ? 'var(--danger)' : 'var(--text-muted)',
                      textDecoration: priceDiff ? 'line-through' : 'none'
                    }}>
                      {p.existing_price ? `${p.existing_price.toFixed(2)} zł` : '-'}
                    </td>
                    <td style={{ padding: '0.4rem 0.5rem', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                      {brakVat ? (
                        <span style={{ color: 'var(--danger)', fontWeight: '600' }}>brak</span>
                      ) : (
                        `${p.stawka_vat}%`
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filtered.length > 200 && (
            <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
              ... i {filtered.length - 200} wi{'ę'}cej produkt{'ó'}w
            </div>
          )}
          {filtered.length === 0 && (
            <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)' }}>
              Brak produkt{'ó'}w spe{'ł'}niaj{'ą'}cych kryteria filtrowania
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '1rem', borderTop: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'var(--bg)' }}>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
            {cennikFilter !== 'all' && (
              <span>Filtr: {opisFiltru[cennikFilter] || cennikFilter} | </span>
            )}
            Wy{'ś'}wietlono: {Math.min(filtered.length, 200)} z {filtered.length} produkt{'ó'}w
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button onClick={onClose}
              style={{ padding: '6px 12px', fontSize: '12px', border: '1px solid var(--border)',
                backgroundColor: 'var(--card-bg)', color: 'var(--text-secondary)', cursor: 'pointer' }}>
              Anuluj
            </button>
            <button onClick={onSave}
              disabled={isSavingCennik}
              style={{
                padding: '6px 12px', fontSize: '12px',
                backgroundColor: isSavingCennik ? 'var(--border)' : 'var(--primary)',
                color: '#fff' , cursor: 'pointer', fontWeight: '600'
              }}>
              {isSavingCennik ? '⏳ Zapisywanie...' : `✅ Aktualizuj cennik (${cennikPreview.stats?.total || 0} produktów)`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CennikImportModal;
